import { render } from "./SalesList.vue?vue&type=template&id=1517b2dc"
import script from "./SalesList.vue?vue&type=script&lang=js"
export * from "./SalesList.vue?vue&type=script&lang=js"

import "./SalesList.vue?vue&type=style&index=0&id=1517b2dc&lang=css"

import exportComponent from "C:\\Users\\MAX\\Documents\\Repositorios\\gem_tpv_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__